import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ToastState {
  show: boolean;
  message: string;
  success: boolean;
  timer: NodeJS.Timeout | null;
  showToast: (message: string, success?: boolean, duration?: number) => void;
  hideToast: () => void;
}

export const useToastStore = create<ToastState>()(
  devtools((set, get) => {
    return {
      show: false,
      message: "",
      success: true,
      timer: null,

      showToast: (message: string, success: boolean = true, duration: number = 3000) => {
        const currentTimer = get().timer;
        if (currentTimer) {
          clearTimeout(currentTimer);
        }

        set({ show: true, message, success }, false, "showToast");

        if (duration > 0) {
          const newTimer = setTimeout(() => {
            set({ show: false, timer: null }, false, "showToast/timeout");
          }, duration);
          set({ timer: newTimer }, false, "showToast/setTimer");
        }
      },

      hideToast: () => {
        const currentTimer = get().timer;
        if (currentTimer) {
          clearTimeout(currentTimer);
        }
        set({ show: false, timer: null }, false, "hideToast");
      },
    };
  }, { name: "toast-store" })
);
